module.exports = __webpack_public_path__ + "img/dku.00110.e3bd12df.png";